import {useMutation} from "@tanstack/react-query";
import axios from "../../../axios";
import {createOrder, CreateOrderRequestPayload} from "./createOrder";
import useToast from "../../../../../hooks/useToast";
import {useErrorLogger} from "../../../../../hooks/useErrorLogger";

export function useCreateOrder() {
  const toastInstance = useToast();
  const logError = useErrorLogger();

  return useMutation({
    mutationFn: async (requestPayload: CreateOrderRequestPayload) => {
      const response = await createOrder(requestPayload, axios);
      return response;
    },
    onSuccess: (data) => {
      window.location.href = data.stripeCheckoutLink;
    },
    onError: (error: any) => {
      toastInstance.error(
        "There was an error on our end, please try again soon"
      );
      logError(error);
    },
  });
}
